module.exports = __webpack_public_path__ + "static/media/bicycle.d577fb31.svg";